import React from 'react';
import { useDispatch } from 'react-redux';
import { toggleCheck } from '../features/projects/projectsSlice';

const SingleProject = ({ project, checked }) => {
  const { id, colorClass, projectName } = project;

  const dispatch = useDispatch();
  return (
    <div className="checkbox-container">
      <input
        type="checkbox"
        className={colorClass}
        checked={checked}
        onChange={() => {
          dispatch(toggleCheck(id));
        }}
      />
      <p className="label">{projectName}</p>
    </div>
  );
};

export default SingleProject;
